import {useForm} from "react-hook-form";
import {useRouter} from "next/router";

const search = ()=>{
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
    } = useForm();
    const router = useRouter();
    const handleForm = async ()=>{
        if(event?.target?.search?.value) router.push(`/busqueda/${encodeURIComponent(event.target.search.value)}`);
        return {};
    };
    return <div className="search marginBottom-big">
        <form className="searchForm" onSubmit={handleSubmit(handleForm)}>
            <input type="text" placeholder="Escribe lo que quieres buscar" autoComplete="off"
                   {...register('search', {
                       required: { value: true, message: 'Escribe algo para buscar' },
                       minLength: {
                           value: 3,
                           message: 'Escribe algo para buscar, debe tener al menos 3 letras'
                       }
                   })}
            />
            <span>{errors?.search?.message}</span>
            <button onClick={e=>{ handleForm() }}>
                Buscar
            </button>
        </form>
    </div>
};

export default search;